import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

// modules class target = '.js-stl-modal' so as to not conflict with .js-shop-the-look for PDP stylitics

export const PLUGIN_NAME = 'shopTheLook';

export default function shopTheLook(el) {
  applyEventHandlers($(el));
}
/**
 * Applies any sort of event handlers for the Shop The Look
 * @param {jQuery} $el - Containing the elements to attach event listeners to
 * @see DEFAULTS
 */
const applyEventHandlers = ($el) => {
  $el.on('click', function(e) {
    const $this = $(this);
    e.preventDefault();

    $.modal({
      url: window.rcProps.shopTheLookModalHref,
      data: $.param({
        qvGroupName: $this.data('qvGroupName'),
        title: $this.data('title'),
        navSrc: $this.data('navSrc'),
      }),
      triggerOpen: true,
      type: 'large',
      fullHeight: true,
      onComplete: function ({ content }) {
        const productBlocks = content.find('.shop-the-look__recs-block');
        const $slick = content.find('.js-shop-the-look-carousel');
        content.css({'overflow':'hidden'});
        let index = 0;
        if ($this.data('activeId')) {
          index = $('.js-qv-item', content).toArray()
            .map((qvItem) => $(qvItem).data('qvId'))
            .indexOf($this.data('activeId')) || 0;
        }


        productBlocks.eq(index).fadeIn(100);
        $slick.slickSlider({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          initialSlide: index,
          dots: true,
          dotsClass: "slick-dots",
          appendDots: content.find(".shop-the-look__styles-dots"),
          rtl: $('html').attr('dir') === 'rtl',
          prevArrow: '.js-stl-carousel__prev',
          nextArrow: '.js-stl-carousel__next',
        });

        $slick.on('beforeChange', function (event, slick, oldSlideIndex, slideIndex) {
          productBlocks.eq(oldSlideIndex).fadeOut(100, function () {
            productBlocks.eq(slideIndex).fadeIn(100);
          });
        });
      }
    })
  });
}

registerJQueryPlugin(PLUGIN_NAME, shopTheLook);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/shop-the-look.js